export const SPECS = {
  AddPoliciesToLineItems: 'specs.stores.AddPoliciesToLineItems',
  UseDeliveryOptionsLibInExpress: 'specs.ecom.UseDeliveryOptionsLibInExpress',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  ErrorHandlerOnCheckout: 'specs.ecom.ErrorHandlerOnCheckout'
};
//# sourceMappingURL=SPECS.js.map